import React from 'react';
import Highlighter from 'react-highlight-words';

const HighlightComponent = ({ highlightClassName = 'highlightClass', className="", searchWords = [], autoEscape = true, textToHighlight = '' }) => {
	return <Highlighter {...{ highlightClassName, className, searchWords, autoEscape, textToHighlight }} />;
};

export default HighlightComponent;
